// extracted by mini-css-extract-plugin
export default {"DropdownMenuItem":"DropdownMenuItem_DropdownMenuItem__ite7B","DropdownMenuItem__active":"DropdownMenuItem_DropdownMenuItem__active__4Mbgb"};